import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeModule} from './pages/home/home.module';
import {BlogModule} from './pages/blog/blog.module';
import {StudyModule} from './pages/study/study.module';

// Note: add export to solve the issue :
//   Cannot read property 'loadChildren' of undefined when compile first time
export function getHomeModule() {
  return HomeModule;
}

export function getStudyModule() {
  return StudyModule;
}

export function getBlogModule() {
  return BlogModule;
}

const routes: Routes = [
  { path: 'home', loadChildren: getHomeModule },
  { path: 'study', loadChildren: getStudyModule },
  { path: 'blog', loadChildren: getBlogModule },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/app-routing.module.ts